/* OORO custom JS — sticky CTA + buy-card ajax + cart upsell */
(function () {
  'use strict';

  /* =================== Sticky CTA ===================
     Riferimento: hero (home) oppure buy box (pagina prodotto). */
  const sticky = document.querySelector('[data-ooro-sticky]');
  const stickyTrigger =
    document.querySelector('.section--ooro-hero') ||
    document.querySelector('.buy-buttons-block') ||
    document.querySelector('product-form-component');
  if (sticky && stickyTrigger) {
    let raf = null;
    const tick = () => {
      const rect = stickyTrigger.getBoundingClientRect();
      const visible = rect.bottom < 100;
      sticky.setAttribute('data-visible', visible ? 'true' : 'false');
      sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
      raf = null;
    };
    window.addEventListener('scroll', () => {
      if (raf) return;
      raf = requestAnimationFrame(tick);
    }, { passive: true });
    tick();
  }

  /* =================== Smooth scroll =================== */
  document.querySelectorAll('a[href^="#ooro-"]').forEach((a) => {
    a.addEventListener('click', (e) => {
      const id = a.getAttribute('href').slice(1);
      const target = document.getElementById(id);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* =================== Buy-card ajax (Horizon-compatible) ===================
     Uses Horizon's native `cart:update` event API (see assets/events.js).
     Opens the cart drawer via multiple fallback strategies. Bulletproof.
  */

  function notifyHorizonCartUpdate(cart, sourceId) {
    const evt = new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart,
        sourceId: sourceId || 'ooro-buy',
        data: {
          itemCount: cart && cart.item_count,
          source: 'ooro-pricing',
        },
      },
    });
    document.dispatchEvent(evt);
  }

  function openHorizonCartDrawer() {
    /* Strategy 1: direct call to cart-drawer-component */
    const drawer = document.querySelector('cart-drawer-component');
    if (drawer) {
      if (typeof drawer.open === 'function') { drawer.open(); return true; }
      if (typeof drawer.showDialog === 'function') { drawer.showDialog(); return true; }
      /* Strategy 2: open the inner <dialog> element */
      const innerDialog = drawer.querySelector('dialog');
      if (innerDialog && typeof innerDialog.showModal === 'function') {
        try { innerDialog.showModal(); return true; } catch (_) {}
      }
    }
    /* Strategy 3: programmatically click the cart icon link */
    const cartLink = document.querySelector(
      'cart-icon-component a, [data-cart-link], a[href$="/cart"], a[href="/cart"]'
    );
    if (cartLink) { cartLink.click(); return true; }
    return false;
  }

  document.querySelectorAll('[data-ooro-buy]').forEach((form) => {
    const btn = form.querySelector('[data-ooro-submit]');
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (!btn || btn.disabled) return;
      const original = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = 'Aggiungo…';
      try {
        const data = new FormData(form);
        if (!data.get('selling_plan')) data.delete('selling_plan');

        /* 1) Add the item to cart */
        const addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: data,
          credentials: 'same-origin',
        });
        if (!addRes.ok) {
          const err = await addRes.json().catch(() => ({}));
          throw new Error(err.description || err.message || 'Errore carrello');
        }

        /* 2) Fetch updated cart state */
        const cartRes = await fetch('/cart.js', { credentials: 'same-origin' });
        const cart = await cartRes.json();

        /* 3) Notify Horizon → cart icon counter updates, drawer refreshes contents */
        notifyHorizonCartUpdate(cart, 'ooro-pricing');

        btn.innerHTML = 'Aggiunto ✓';

        /* 4) Open the cart drawer (or navigate to /cart as last resort) */
        setTimeout(function () {
          var opened = openHorizonCartDrawer();
          if (!opened) {
            /* Last resort fallback: navigate to /cart page */
            window.location.href = '/cart';
          }
        }, 120);

        setTimeout(function () { btn.innerHTML = original; btn.disabled = false; }, 1400);
      } catch (err) {
        console.error('[OORO buy-card]', err);
        btn.innerHTML = 'Errore — riprova';
        setTimeout(function () { btn.innerHTML = original; btn.disabled = false; }, 1800);
      }
    });
  });

  /* =================== Universal "#ooro-add-to-cart" links ===================
     Qualsiasi <a href="#ooro-add-to-cart"> (header CTA, bottoni vari) aggiunge
     il prodotto globale al carrello e apre il drawer. Editabile: basta puntare
     il link a #ooro-add-to-cart dall'editor del tema. */
  document.addEventListener('click', async function (e) {
    var trigger = e.target.closest('a[href*="#ooro-add-to-cart"], [data-ooro-atc]');
    if (!trigger) return;
    e.preventDefault();
    var variantId = trigger.getAttribute('data-ooro-variant') || window.OORO_ATC_VARIANT;
    if (!variantId) { window.location.href = '/cart'; return; }
    var original = trigger.innerHTML;
    try {
      var body = new FormData();
      body.append('id', variantId);
      body.append('quantity', '1');
      var addRes = await fetch('/cart/add.js', {
        method: 'POST', headers: { Accept: 'application/json' },
        body: body, credentials: 'same-origin',
      });
      if (!addRes.ok) throw new Error('cart add failed');
      var cart = await (await fetch('/cart.js', { credentials: 'same-origin' })).json();
      if (typeof notifyHorizonCartUpdate === 'function') notifyHorizonCartUpdate(cart, 'ooro-header');
      setTimeout(function () {
        var opened = (typeof openHorizonCartDrawer === 'function') && openHorizonCartDrawer();
        if (!opened) window.location.href = '/cart';
      }, 120);
    } catch (err) {
      console.error('[OORO atc-link]', err);
      window.location.href = '/cart';
    }
  });

  /* =================== Cart Upsell handlers =================== */
  /* Uses event delegation on document to catch upsell buttons that may render
     inside dynamically-loaded cart drawer. */

  async function postCart(endpoint, body) {
    const res = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(body),
      credentials: 'same-origin',
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || err.message || 'Errore carrello');
    }
    return res.json();
  }

  function refreshCartUI() {
    /* Tries Horizon's known refresh mechanisms in order */
    /* 1) Custom event */
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
    /* 2) Trigger Horizon's cart-items-component refetch */
    document.querySelectorAll('cart-items-component').forEach((el) => {
      if (typeof el.refresh === 'function') el.refresh();
      if (typeof el.update === 'function') el.update();
    });
    /* 3) Fallback: reload page */
    setTimeout(() => {
      const stillBroken = document.querySelector('[data-ooro-upsell]')?.dataset.ooroLoadingFailed === 'true';
      if (stillBroken) window.location.reload();
    }, 300);
  }

  async function handleUpsellClick(btn) {
    const action = btn.dataset.ooroUpsellAction;
    if (!action || btn.disabled) return;
    const originalLabel = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = '…';
    try {
      if (action === 'change-qty') {
        const key = btn.dataset.itemKey;
        const qty = parseInt(btn.dataset.newQty, 10);
        await postCart('/cart/change.js', { id: key, quantity: qty });
      } else if (action === 'switch-to-sub') {
        /* Remove the item, then add it again with selling_plan */
        const key = btn.dataset.itemKey;
        const variantId = parseInt(btn.dataset.variantId, 10);
        const planId = parseInt(btn.dataset.planId, 10);
        await postCart('/cart/change.js', { id: key, quantity: 0 });
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1, selling_plan: planId }],
          }),
          credentials: 'same-origin',
        });
      } else if (action === 'add-product') {
        const variantId = parseInt(btn.dataset.variantId, 10);
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
          credentials: 'same-origin',
        });
      }
      btn.innerHTML = '✓';
      /* Force a reload to refresh the cart drawer/page reliably */
      window.location.reload();
    } catch (err) {
      console.error('[OORO Upsell]', err);
      btn.innerHTML = 'Errore';
      setTimeout(() => { btn.innerHTML = originalLabel; btn.disabled = false; }, 1800);
    }
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-ooro-upsell-action]');
    if (!btn) return;
    e.preventDefault();
    handleUpsellClick(btn);
  });

})();


/* ===========================================
   OORO Motion · subtle reveals + stat counters
   =========================================== */
(function () {
  'use strict';

  if (typeof IntersectionObserver === 'undefined') return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* ---------- Reveal on scroll ---------- */
  // Auto-tag: section headlines + cards + stats get .ooro-reveal automatically
  var autoSelector = [
    '.ooro-section-headline',
    '.ooro-hero__headline',
    '.ooro-solution__headline',
    '.ooro-pricing__headline',
    '.ooro-guarantee__headline',
    '.ooro-cta-final__headline',
    '.ooro-card',
    '.ooro-ingredient',
    '.ooro-timeline__step',
    '.ooro-stat',
    '.ooro-pricing__col',
    '.ooro-review',
    '.ooro-faq__item',
    '.ooro-authority__item',
    '.ooro-howto__step',
    '.ooro-comparison__table'
  ].join(',');

  document.querySelectorAll(autoSelector).forEach(function (el) {
    if (!el.classList.contains('ooro-reveal')) el.classList.add('ooro-reveal');
  });

  var revealObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

  document.querySelectorAll('.ooro-reveal').forEach(function (el) {
    revealObserver.observe(el);
  });

  /* ---------- Stat counter animation ---------- */
  var counterObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        animateStatNumber(entry.target);
        counterObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.5 });

  document.querySelectorAll('.ooro-stat__num').forEach(function (el) {
    counterObserver.observe(el);
  });

  function animateStatNumber(el) {
    var raw = (el.textContent || '').trim();
    // Estrae la parte numerica e conserva il suffisso (es. "20%" -> num=20, suffix="%")
    var match = raw.match(/^(\d+(?:[.,]\d+)?)(.*)$/);
    if (!match) return;
    var target = parseFloat(match[1].replace(',', '.'));
    if (isNaN(target) || target <= 0) return;
    var suffix = match[2] || '';
    var hasDecimal = match[1].indexOf(',') !== -1 || match[1].indexOf('.') !== -1;

    var duration = 1200; // ms
    var startTime = null;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var elapsed = timestamp - startTime;
      var progress = Math.min(elapsed / duration, 1);
      // ease-out cubic
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = target * eased;
      el.textContent = (hasDecimal ? current.toFixed(1).replace('.', ',') : Math.round(current)) + suffix;
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        el.textContent = match[1] + suffix; // ripristina valore esatto
      }
    }
    requestAnimationFrame(step);
  }
})();


/* ===========================================
   OORO Motion · Hero headline word reveal
   =========================================== */
(function () {
  'use strict';

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var headline = document.querySelector('.ooro-hero__headline');
  if (!headline) return;

  // Wrap each word in <span class="ooro-word"> preserving the original line spans
  var lines = headline.querySelectorAll('span');
  if (lines.length === 0) return;

  var wordIndex = 0;
  lines.forEach(function (line) {
    var text = line.textContent.trim();
    if (!text) return;
    var words = text.split(/\s+/);
    line.innerHTML = words.map(function (w) {
      var i = wordIndex++;
      return '<span class="ooro-word" style="transition-delay:' + (i * 90) + 'ms">' + w + '</span>';
    }).join(' ');
  });

  // Reveal on first paint (small delay to ensure CSS applies)
  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      headline.querySelectorAll('.ooro-word').forEach(function (w) {
        w.classList.add('is-visible');
      });
    });
  });
})();


/* ===========================================
   OORO Cinematic Intro — Password landing only
   Total runtime: ~2,5s
   =========================================== */
(function () {
  'use strict';

  var intro = document.querySelector('[data-ooro-intro]');
  if (!intro) return;

  /* Skip se l'utente l'ha già vista in questa sessione */
  try {
    if (sessionStorage.getItem('ooroIntroSeen') === '1') {
      intro.parentNode && intro.parentNode.removeChild(intro);
      return;
    }
  } catch (e) {
    /* sessionStorage potrebbe non essere disponibile (modalità privata strict) — continua comunque */
  }

  /* Skip su reduced motion */
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    intro.parentNode && intro.parentNode.removeChild(intro);
    return;
  }

  /* Lock scroll durante l'intro */
  var origOverflow = document.body.style.overflow;
  document.body.style.overflow = 'hidden';

  var finished = false;
  var timers = [];

  function finish() {
    if (finished) return;
    finished = true;
    timers.forEach(function (t) { clearTimeout(t); });
    try { sessionStorage.setItem('ooroIntroSeen', '1'); } catch (e) {}
    intro.classList.add('ooro-intro--fading');
    setTimeout(function () {
      if (intro.parentNode) intro.parentNode.removeChild(intro);
      document.body.style.overflow = origOverflow;
    }, 320);
  }

  /* Skip button */
  var skipBtn = intro.querySelector('[data-ooro-intro-skip]');
  if (skipBtn) skipBtn.addEventListener('click', finish);

  /* Esc per skippare */
  var escHandler = function (e) {
    if (e.key === 'Escape') {
      finish();
      document.removeEventListener('keydown', escHandler);
    }
  };
  document.addEventListener('keydown', escHandler);

  /* Avvia animazione al prossimo frame (assicura che il CSS iniziale sia applicato) */
  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      intro.classList.add('ooro-intro--playing');
    });
  });

  /* Sequenza:
     T+0      → playing (lettere arrivano, ultima a 450+580=1030ms)
     T+1080   → sub fade-in (380ms, ends 1460ms)
     T+1500   → shrinking start (600ms transition, ends 2100ms)
     T+2180   → finish() → fade overlay (320ms, ends 2500ms)
  */
  timers.push(setTimeout(function () {
    intro.classList.add('ooro-intro--shrinking');
  }, 1500));

  timers.push(setTimeout(finish, 2180));
})();

/* ==========================================================
   OORO · Launch Bar countdown
   Parses data-end="YYYY-MM-DD HH:MM" and counts down live.
   Hides bar when expired. Ticks every second.
   ========================================================== */
(function initOoroLaunchBar() {
  function boot() {
    var bar = document.querySelector('[data-ooro-launch-bar]');
    if (!bar) return;
    var timerEl = bar.querySelector('[data-ooro-launch-timer]');
    if (!timerEl) return;
    var endStr = (bar.getAttribute('data-end') || '').trim();
    if (!endStr) return;

    // Parse "YYYY-MM-DD HH:MM" as local time (avoids UTC shift confusion).
    var m = endStr.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?$/);
    if (!m) {
      timerEl.textContent = '';
      return;
    }
    var endTime = new Date(
      parseInt(m[1], 10),
      parseInt(m[2], 10) - 1,
      parseInt(m[3], 10),
      parseInt(m[4], 10),
      parseInt(m[5], 10),
      m[6] ? parseInt(m[6], 10) : 0
    ).getTime();
    if (isNaN(endTime)) return;

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    var interval = null;
    function tick() {
      var diff = endTime - Date.now();
      if (diff <= 0) {
        bar.style.display = 'none';
        if (interval) clearInterval(interval);
        return;
      }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var mi = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);

      var out;
      if (d > 0) {
        out = d + 'g ' + pad(h) + 'h ' + pad(mi) + 'm ' + pad(s) + 's';
      } else if (h > 0) {
        out = pad(h) + 'h ' + pad(mi) + 'm ' + pad(s) + 's';
      } else {
        out = pad(mi) + 'm ' + pad(s) + 's';
      }
      timerEl.textContent = out;
    }

    tick();
    interval = setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* ==========================================================
   OORO · Dynamic Klarna rate
   Updates 3-rate figure when the quantity radio changes in
   the tier-based buy form. Uses data-total (cents) on each
   radio. Falls back to no-op if the elements are missing.
   ========================================================== */
(function initOoroDynamicKlarna() {
  function formatEuroFromCents(cents) {
    if (!Number.isFinite(cents) || cents < 0) cents = 0;
    var euros = cents / 100;
    var formatted = euros.toFixed(2).replace('.', ',');
    return '€' + formatted;
  }

  function boot() {
    document.querySelectorAll('form[data-ooro-buy-tiers]').forEach(function (form) {
      var rateEl = form.querySelector('[data-klarna-rate]');
      if (!rateEl) return;

      var radios = form.querySelectorAll('input[type="radio"][name="quantity"]');
      if (!radios.length) return;

      function update() {
        var checked = form.querySelector('input[type="radio"][name="quantity"]:checked');
        if (!checked) return;
        var totalCents = parseInt(checked.getAttribute('data-total'), 10);
        if (!Number.isFinite(totalCents)) return;
        var rateCents = Math.floor(totalCents / 3);
        rateEl.textContent = formatEuroFromCents(rateCents);
      }

      radios.forEach(function (r) { r.addEventListener('change', update); });
      update();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* ==========================================================
   OORO · Cart delivery date
   Updates "Ricevi entro" inside cart drawer/page after AJAX refreshes.
   ========================================================== */
(function initOoroCartDeliveryDate() {
  'use strict';

  var updateFrame = null;

  function addBusinessDays(date, days) {
    var result = new Date(date);
    var added = 0;

    while (added < days) {
      result.setDate(result.getDate() + 1);

      if (result.getDay() !== 0 && result.getDay() !== 6) {
        added += 1;
      }
    }

    return result;
  }

  function getDeliveryText() {
    var deliveryDate = addBusinessDays(new Date(), 3);

    return deliveryDate.toLocaleDateString('it-IT', {
      weekday: 'long',
      day: 'numeric',
      month: 'long'
    });
  }

  function updateDeliveryDates() {
    var deliveryText = getDeliveryText();
    var targets = document.querySelectorAll('.ooro-cart-delivery-date');

    targets.forEach(function (target) {
      if (target.textContent.trim() !== deliveryText) {
        target.textContent = deliveryText;
      }
    });
  }

  function scheduleUpdate() {
    if (updateFrame) return;

    updateFrame = window.requestAnimationFrame(function () {
      updateFrame = null;
      updateDeliveryDates();
    });
  }

  function boot() {
    updateDeliveryDates();
    setTimeout(updateDeliveryDates, 100);
    setTimeout(updateDeliveryDates, 500);
    setTimeout(updateDeliveryDates, 1200);

    document.addEventListener('cart:update', scheduleUpdate);
    document.addEventListener('cart:updated', scheduleUpdate);
    document.addEventListener('cart:refresh', scheduleUpdate);
    document.addEventListener('shopify:section:load', scheduleUpdate);

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();